export default __webpack_public_path__ + "static/media/workday-seeklogo.5d264982.svg";